import { ProductListComponent } from '../product-list.component';
import { Component } from '@angular/core';
import { RootReducer, Store } from '@app/app.reducers';
import { DataLayer } from '@app/shared/services/data-layer.service';

@Component({
	selector: 'g-product-list-thumbnail',
	templateUrl: './product-list-thumbnail.component.html',
	styleUrls: ['./product-list-thumbnail.component.scss', '../product-list.component.scss'],
})
export class ProductListThumbnailComponent extends ProductListComponent {
	constructor(protected store: Store<RootReducer.State>, protected dataLayer: DataLayer) {
		super(store, dataLayer);
	}
}
